<section class="category-panel" aria-label="产品分类区">
  <div class="category-tabs">
    <button
      *ngFor="let c of categories"
      class="category-tab"
      [class.active]="activeCategory?.name === c.name"
      (click)="setActiveCategory(c)"
      type="button"
    >
      <span class="tab-icon">
        <app-image
          *ngIf="c.icon"
          [fileid]="c.icon"
          style="width: 34px; height: 34px;"
        ></app-image>
      </span>
      <span>{{ c.name }}</span>
    </button>
  </div>
</section>

<div class="catalog-heading">
  <div class="product-count">
    当前展示 <strong>{{ activePlatforms.length }}</strong> 种产品
  </div>
</div>

<div class="catalog-grid">
  <app-platform-card
    *ngFor="let p of activePlatforms"
    [data]="p"
    [attr.id]="'platform-card-' + p.id"
  ></app-platform-card>
</div>

<div class="empty-state" [class.show]="activePlatforms.length === 0">
  <strong>当前分类暂无产品</strong><br />
  <span>请选择其他分类。</span>
</div>
